var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-container",on:{"click":_vm.onClick}},[_c('span',[_vm._v("\n        "+_vm._s(_vm.text)+"\n        "),(_vm.materialIconName)?_c('md-icon',{staticClass:"btn-icon",staticStyle:{"fill":"red"}},[_vm._v("\n            "+_vm._s(_vm.materialIconName)+"\n        ")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-267eed0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button/Button.vue
// module id = null
// module chunks = 